// extracted by mini-css-extract-plugin
export default {"link":"signUp_link__a+jFp","greenSpan":"signUp_greenSpan__miG-R","redSpan":"signUp_redSpan__k+0LA"};